var errorTempl = require('sma.common/partials/form_errors.mustache')

var addErrors = function(elem, errors) {
	for (var id in errors) {
		var temp = errorTempl({
			message: errors[id]
		})
		var field = elem.find("#id_" + id);
		var parent = field.parent();
		if (!parent.find('.errorlist').length) {
			$(temp).insertAfter(field);
		}
	}
}

var removeErrors = function(elem) {
	elem.find('.errorlist').remove();
}

module.exports = {
	addErrors: addErrors,
	removeErrors: removeErrors,
};